<!-- 底部 -->
<template>
  <footer class="footer">
    <div class="footer-left">© Zkware Inc. 2025</div>
    <div class="footer-right">zkwarebd@gmail.com</div>
  </footer>
</template>

<style scoped>
.footer {
  background: #232323;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 48px 48px 32px 48px; /* 上下内边距加大 */
  min-height: 110px; /* 增加最小高度 */
  border-top: none;
  font-size: 1.05rem;
  box-sizing: border-box;
}

.footer-left {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.footer-right {
  font-weight: 500;
  letter-spacing: 0.5px;
  text-align: right;
}

@media (max-width: 700px) {
  .footer {
    flex-direction: column;
    gap: 8px;
    padding: 32px 8vw 24px 8vw; /* 上下padding也加大 */
    font-size: 0.98rem;
    min-height: 90px;
  }
  .footer-right {
    text-align: center;
    width: 100%;
  }
}
</style>
